<template  src='./VerTarjetaMiniaturaExpansible.html'></template>
<script>
import { consultarInformacionTarjetaEspecifica } from "../../apiService/request/CrudFormulario";
import { consultarEstructuraCuestionarioPorId } from "../../apiService/request/CrudSeguimiento";
import VerTarjetasNuevasMomento from "../VerTarjetasNuevasMomento/VerTarjetasNuevasMomento";
export default {
  data() {
    return {
      texto_introductorio: null,
      banderaAbrirTarjeta: false,
      informacionFormularioEspecifico: [],
      deshabilitado: true
    };
  },
  components: {
    VerTarjetasNuevasMomento
  },
  created() {},
  props: {
    // deshabilitado:
    // {
    //   type: Boolean,
    //   default: true
    // },
    tarjetaFormularioMomento: {
      required: true
    }
  },
  methods: {
    abrirTarjetaFormularioMomento(formulario) {
      this.banderaAbrirTarjeta = !this.banderaAbrirTarjeta;
      this.InformacionTarjetaEspecifica(formulario);
      // serverBus.$emit("abrirTarjetaFormulario", formulario_id, nombreCategoria);
    },
    async InformacionTarjetaEspecifica(formulario) {
      try {
        const respuesta = await consultarEstructuraCuestionarioPorId(
          formulario.id,
          formulario.coleccion,
          formulario.nombre
        );
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.texto_introductorio) {
          this.texto_introductorio = respuesta.data.data.texto_introductorio;
        } else {
          this.texto_introductorio = null;
        }
        this.$store.dispatch(
          "setVariablesFormulariosOverlay",
          respuesta.data.data.variables
        );
        this.$store.dispatch("setNombreFormularioOverlay", respuesta.data.data.key);
        this.$store.dispatch("setColeccionOverlay", respuesta.data.data.coleccion);
        // this.informacionFormularioEspecifico=respuesta.data.data.variables;
      } catch (err) {}
    }
  }
};
</script>
<style  src='./VerTarjetaMiniaturaExpansible.scss' lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/VerTarjetaMiniaturaExpansible/VerTarjetaMiniaturaExpansible.vue